import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faClipboardList, faBars } from "@fortawesome/free-solid-svg-icons";
import { Package } from "lucide-react";
import { faList } from "@fortawesome/free-solid-svg-icons"; 


const MenuFooter = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('');
  const [moreOpen, setMoreOpen] = useState(false);

  const moreRef = useRef(null); 

  // Detect active tab from route
  useEffect(() => {
    const path = location.pathname.toLowerCase(); 
    if (path === '/consumer/projectdetails') setActiveTab('home');
    else if (path.includes('/consumer/app/rfqlist')) setActiveTab('rfq');
    else if (path.includes('/consumer/orders')) setActiveTab('orders');
    else if (path.includes('/consumer/cartpreview')) setActiveTab('bucket');
    else if (path.includes('/consumer/app/materiallist')) setActiveTab('materialList');
    // else if (path.includes('/consumer/more') || path.includes('/consumer/profileaccount')) setActiveTab('more');
   else if (path.includes('/consumer/userdashboard')) setActiveTab('more');

  }, [location.pathname]);

  // Close More dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (moreRef.current && !moreRef.current.contains(event.target)) {
        setMoreOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleNavigation = (route, tabName) => {
    setActiveTab(tabName);
    window.scrollTo(0, 0);
    navigate(route);
    setMoreOpen(false); // Close More on navigation
  };

  const handleLogout = () => {
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = '/consumer';
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-white shadow-md border-t border-gray-200">
      <div className="flex justify-between items-center px-2">
        {/* Home */}
        <button 
          className="flex flex-col items-center flex-1 py-3 relative mt-2"
          onClick={() => handleNavigation('/consumer/Projectdetails', 'home')}
        >
          {activeTab === 'home' && (
            <div className="absolute -top-px left-1/2 transform -translate-x-1/2 w-10 h-0.5 bg-red-400"></div>
          )}
          <FontAwesomeIcon
            icon={faHome}
            size="lg"
            className={`mb-1 ${activeTab === 'home' ? 'text-red-400' : 'text-gray-600'}`}
          />
          <span className={`text-xs ${activeTab === 'home' ? 'text-red-400 font-medium' : 'text-gray-700'}`}>
            Home
          </span>
        </button>

      <button
      className="flex flex-col items-center flex-1 py-3 relative mt-2"
      onClick={() => handleNavigation('/consumer/app/materiallist', 'materialList')}
    >
      {activeTab === 'materialList' && (
        <div className="absolute -top-px left-1/2 transform -translate-x-1/2 w-12 h-0.5 bg-red-400"></div>
      )}
      <FontAwesomeIcon
        icon={faList} // or any other list icon
        size="lg"
        className={`mb-1 ${activeTab === 'materialList' ? 'text-red-400' : 'text-gray-600'}`}
      />
    <span
  className={`text-xs whitespace-nowrap ${activeTab === 'materialList' ? 'text-red-400 font-medium' : 'text-gray-700'}`}
>
   Requirements
</span>

    </button>


        {/* RFQ */}
        {/* <button
          className="flex flex-col items-center flex-1 py-3 relative mt-2"
          onClick={() => handleNavigation('/consumer/rfq', 'rfq')}
        >
          {activeTab === 'rfq' && (
            <div className="absolute -top-px left-1/2 transform -translate-x-1/2 w-10 h-0.5 bg-red-400"></div>
          )}
          <FontAwesomeIcon
            icon={faClipboardList}
            size="lg"
            className={`mb-1 ${activeTab === 'rfq' ? 'text-red-400' : 'text-gray-600'}`}
          />
          <span className={`text-xs ${activeTab === 'rfq' ? 'text-red-400 font-medium' : 'text-gray-700'}`}>
            RFQ
          </span>
        </button> */}

        {/* Orders */}
        <button
          className="flex flex-col items-center flex-1 py-3 relative mt-2"
          onClick={() => handleNavigation('/consumer/orders', 'orders')}
        >
          {activeTab === 'orders' && (
            <div className="absolute -top-px left-1/2 transform -translate-x-1/2 w-12 h-0.5 bg-red-400"></div>
          )}
          <Package
            className={`mb-1 ${activeTab === 'orders' ? 'text-red-400' : 'text-gray-600'}`}
            size={20}
          />
          <span className={`text-xs ${activeTab === 'orders' ? 'text-red-400 font-medium' : 'text-gray-700'}`}>
           Orders
          </span>
        </button>

   

        {/* More */}
        <div className="relative flex-1">
          <button
            className="flex flex-col items-center w-full py-3 relative mt-2"
            
          onClick={() => handleNavigation('/consumer/userDashboard', 'more')}

          >
            {activeTab === 'more' && (
              <div className="absolute -top-px left-1/2 transform -translate-x-1/2 w-10 h-0.5 bg-red-400"></div>
            )}
            <FontAwesomeIcon
              icon={faBars}
              size="lg"
              className={`mb-1 ${activeTab === 'more' ? 'text-red-400' : 'text-gray-600'}`}
            />
            <span className={`text-xs ${activeTab === 'more' ? 'text-red-400 font-medium' : 'text-gray-700'}`}>
              More
            </span>
          </button>

          {/* Dropdown */}
         {/* {moreOpen && (
  <div className="absolute right-0 bottom-14 w-32 bg-white rounded-md shadow-lg py-1 z-40 border border-gray-200">
    <button 
      onClick={() => handleNavigation('/consumer/ProfileAccount', 'more')} 
      className="block w-full text-left px-2 py-1 text-sm text-gray-700 hover:bg-gray-100"
    >
      Profile
    </button>

    <button 
      onClick={handleLogout}
      className="block w-full text-left px-2 py-1 text-sm text-red-600 hover:bg-gray-100"
    >
      Logout
    </button>

    <button 
      onClick={() => navigate('/consumer/UserDashboard')}
      className="block w-full text-left px-2 py-1 text-sm text-gray-700 hover:bg-gray-100"
    >
      User Dashboard
    </button>
  </div>
)} */}

        </div>
      </div>
    </div>
  );
};

export default MenuFooter;
